import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminVideos() {
  const [videos, setVideos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState(null);
  const [form, setForm] = useState({ titre: '', annee: '', type: 'CLIP OFFICIEL', description: '' });
  const fileRef = useRef();
  const navigate = useNavigate();

  const [logged] = useState(sessionStorage.getItem('mjadmin') === 'ok');
  const token = sessionStorage.getItem('mjadmin_token');

  useEffect(() => {
    if (!token) { navigate('/admin'); return; }
    chargerVideos();
  }, []);

  const chargerVideos = async () => {
    const res = await fetch('/api/videos');
    const data = await res.json();
    setVideos(data);
  };

  const handleUpload = async () => {
    const file = fileRef.current?.files[0];
    if (!file) return setMessage({ type: 'error', texte: 'Sélectionnez une vidéo' });
    if (!form.titre.trim()) return setMessage({ type: 'error', texte: 'Le titre est obligatoire' });

    const fd = new FormData();
    fd.append('video', file);
    fd.append('titre', form.titre);
    fd.append('annee', form.annee);
    fd.append('type', form.type);
    fd.append('description', form.description);

    setUploading(true);
    setProgress(0);

    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = e => {
      if (e.lengthComputable) setProgress(Math.round(e.loaded / e.total * 100));
    };
    xhr.onload = () => {
      setUploading(false);
      if (xhr.status === 200) {
        setMessage({ type: 'success', texte: 'Vidéo uploadée avec succès !' });
        setForm({ titre: '', annee: '', type: 'CLIP OFFICIEL', description: '' });
        fileRef.current.value = '';
        chargerVideos();
      } else {
        setMessage({ type: 'error', texte: 'Erreur lors de l\'upload' });
      }
    };
    xhr.onerror = () => { setUploading(false); setMessage({ type: 'error', texte: 'Erreur réseau' }); };
    xhr.open('POST', '/api/videos/upload');
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.send(fd);
  };

  const handleSupprimer = async (filename) => {
    if (!window.confirm(`Supprimer "${filename}" ?`)) return;
    const res = await fetch(`/api/videos/${filename}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
    if (res.ok) { setMessage({ type: 'success', texte: 'Vidéo supprimée' }); chargerVideos(); }
  };

  const input = (label, key, type = 'text', opts = {}) => (
    <div style={{ marginBottom: 16 }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>{label}</label>
      {type === 'select' ? (
        <select value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
          style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13 }}>
          {opts.options.map(o => <option key={o}>{o}</option>)}
        </select>
      ) : type === 'textarea' ? (
        <textarea value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
          rows={3} style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, resize: 'vertical', boxSizing: 'border-box' }} />
      ) : (
        <input type={type} value={form[key]} onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
          style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, boxSizing: 'border-box' }} />
      )}
    </div>
  );

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif', padding: '40px 48px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 36 }}>
          <button onClick={() => navigate('/admin')} style={{ padding: '8px 16px', borderRadius: 8, border: '1.5px solid #c49090', background: '#fff', color: '#8b1a2a', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            ← Admin
          </button>
          <div>
            <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700 }}>ADMINISTRATION</div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 24, color: '#1a1010' }}>Gestion des vidéos Michael</div>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 32, alignItems: 'start' }}>

          {/* Formulaire upload */}
          <div style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderRadius: 14, padding: '28px 24px' }}>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#8b1a2a', marginBottom: 20 }}>Ajouter une vidéo</div>

            {message && (
              <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 16, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 13, fontWeight: 600 }}>
                {message.type === 'success' ? '✓' : '✗'} {message.texte}
              </div>
            )}

            {input('Titre *', 'titre')}
            {input('Année', 'annee', 'text')}
            {input('Type', 'type', 'select', { options: ['CLIP OFFICIEL', 'LIVE HISTORIQUE', 'CONCERT', 'LIVE RARE', 'COULISSES'] })}
            {input('Description', 'description', 'textarea')}

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 5 }}>Fichier vidéo (MP4, WebM) *</label>
              <input ref={fileRef} type="file" accept="video/mp4,video/webm,video/ogg"
                style={{ width: '100%', padding: '9px 12px', borderRadius: 8, border: '1.5px solid #c49090', fontSize: 13, background: '#fff', boxSizing: 'border-box' }} />
            </div>

            {uploading && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6a5050', marginBottom: 5 }}>
                  <span>Upload en cours…</span><span>{progress}%</span>
                </div>
                <div style={{ height: 8, background: '#f5eeeb', borderRadius: 4, overflow: 'hidden' }}>
                  <div style={{ height: '100%', background: '#8b1a2a', width: `${progress}%`, transition: 'width 0.3s', borderRadius: 4 }}></div>
                </div>
              </div>
            )}

            <button onClick={handleUpload} disabled={uploading}
              style={{ width: '100%', padding: '12px', borderRadius: 8, border: 'none', background: uploading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 14, cursor: uploading ? 'not-allowed' : 'pointer' }}>
              {uploading ? `Upload ${progress}%…` : '⬆ Uploader la vidéo'}
            </button>
          </div>

          {/* Liste des vidéos */}
          <div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#1a1010', marginBottom: 16 }}>
              Vidéos stockées <span style={{ fontSize: 14, color: '#8b1a2a' }}>({videos.length})</span>
            </div>
            {videos.length === 0 ? (
              <div style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderRadius: 12, padding: '32px', textAlign: 'center', color: '#9a8080', fontSize: 14 }}>
                Aucune vidéo uploadée pour le moment.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {videos.map(v => (
                  <div key={v.filename} style={{ background: '#fff', border: '1.5px solid #e8d5d0', borderRadius: 12, padding: '16px 18px', display: 'flex', gap: 16, alignItems: 'center' }}>
                    <video src={v.url} style={{ width: 120, height: 70, objectFit: 'cover', borderRadius: 8, background: '#1a0808', flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010', marginBottom: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.filename}</div>
                      <a href={v.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#8b1a2a', wordBreak: 'break-all' }}>{v.url}</a>
                    </div>
                    <button onClick={() => handleSupprimer(v.filename)}
                      style={{ padding: '7px 14px', borderRadius: 8, border: '1.5px solid #c49090', background: '#fff', color: '#8b1a2a', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
                      🗑 Supprimer
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}
